import { ColumnDef, createColumnHelper } from '@tanstack/react-table'

import Currency from 'components/ui/Currency'

import { OrdersDetailsDataTypes } from 'types/orders-details-westfieldcons'

export const useTablesOrdersDetails = ({
  dataTable,
}: {
  dataTable: OrdersDetailsDataTypes[]
}) => {
  const columnHelper = createColumnHelper<OrdersDetailsDataTypes>()
  const columns = [
    columnHelper.accessor('productName', {
      header: () => 'Product',
      cell: (info) => {
        const productName = info.getValue()

        return (
          <p className="flex flex-col uppercase">
            <span>{productName}</span>
          </p>
        )
      },
    }),
    columnHelper.accessor('unitPrice', {
      header: () => 'Price',
      cell: ({ row }) => {
        const { original } = row
        const { quantity, unitPrice } = original
        const price = quantity * unitPrice

        return (
          <p className="font-bold">
            {unitPrice.toLocaleString(undefined, {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
            })}
            <Currency countryCode={'NZ'} />
          </p>
        )
      },
    }),
    columnHelper.accessor('quantity', {
      header: () => 'Quantity',
      cell: (info) => {
        const quantity = info.getValue()

        return (
          <p className="flex flex-col">
            <span>{quantity}</span>
          </p>
        )
      },
    }),
    columnHelper.accessor('unitPrice', {
      header: () => 'Amount',
      cell: ({ row }) => {
        const { original } = row
        const { quantity, unitPrice } = original
        const price = quantity * unitPrice

        return (
          <p className="font-bold">
            {price.toLocaleString(undefined, {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
            })}
            <Currency countryCode={'NZ'} />
          </p>
        )
      },
    }),
  ] as ColumnDef<OrdersDetailsDataTypes>[]

  return {
    dataTable,
    columns,
  }
}
